export const PROCESS_ERROR_WRONG_FILE_TYPE = 'WRONG_FILE_TYPE';
export const PROCESS_ERROR_WHEN_READ_FILE = 'ERROR_WHEN_READ_FILE';
export const PROCESS_SUCCESS_WHEN_READ_FILE = 'SUCCESS_WHEN_READ_FILE';
